import api from '../lib/api';
import type { ApiResponse } from '@maios/shared';

export interface IPWhitelistConfig {
  enabled: boolean;
  allowedIPs: string[];
  excludeLogin: boolean;
  currentIP?: string;
}

export async function getIPWhitelist(): Promise<IPWhitelistConfig> {
  const res = await api.get<ApiResponse<IPWhitelistConfig>>('/admin/settings/ip-whitelist');
  return res.data.data!;
}

export async function updateIPWhitelist(data: {
  enabled: boolean;
  allowedIPs: string[];
  excludeLogin: boolean;
}): Promise<{ data: IPWhitelistConfig; message?: string }> {
  const res = await api.put<ApiResponse<IPWhitelistConfig>>('/admin/settings/ip-whitelist', data);
  return { data: res.data.data!, message: res.data.message };
}
